// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3i-1";
export var movingGradient = "_3i-4";
export var movingGradientBlock = "_3i-2";
export var skeleton = "_3i-0";
export var skeletonText = "_3i-3";